__webpack_public_path__ = window.__webpack_public_path__;
import 'regenerator-runtime/runtime';
import '../scss/app.scss';

export default class App {
  init() {
    this.importController();
  }



  importController() {
    let pageType = document.querySelector('html');
    let controller =
      (pageType.dataset.controller && pageType.dataset.controller !== "")
      ? pageType.dataset.controller
      : "Controller";

    import(
      /* webpackChunkName:`controller-[request]` */
      /* webpackMode: "lazy" */
      `./controllers/${controller}`
    ).then(async ({ default: controller }) => {
        let newContr = new controller();
      })
      .catch(error => {
      console.error("No data-controller detected on html tag");
      console.dir(error);
    });
  }
}



let app = new App();
app.init();